import { useMutation } from '@tanstack/react-query';
import { useSharedDataprivacyApi } from 'services';

export const useDeletePerson = () => {
  const { deletePerson } = useSharedDataprivacyApi();

  return useMutation({ mutationFn: deletePerson });
};
